export default __webpack_public_path__ + "06101c4f9b5909bf686bbc4420722ac0.png";